// FAQ Accordion and Category Filtering

export function initFaqAccordion() {
    // Initialize accordion behavior
    document.querySelectorAll('.faq-toggle').forEach(button => {
        button.addEventListener('click', () => {
            const item = button.closest('.faq-item');
            const isOpen = item.classList.contains('open');

            // Close all other FAQ items
            document.querySelectorAll('.faq-item.open').forEach(openItem => {
                if (openItem !== item) {
                    openItem.classList.remove('open');
                    openItem.querySelector('.faq-toggle').setAttribute('aria-expanded', 'false');
                }
            });

            // Toggle current item
            if (isOpen) {
                item.classList.remove('open');
                button.setAttribute('aria-expanded', 'false');
            } else {
                item.classList.add('open');
                button.setAttribute('aria-expanded', 'true');
            }
        });
    });

    // Initialize category filtering
    initFaqCategoryFiltering();
}

/**
 * Initialize FAQ category filtering with animated transitions
 */
function initFaqCategoryFiltering() {
    const categoryLinks = document.querySelectorAll('.faq-category-link');
    const categoryGroups = document.querySelectorAll('.faq-category-group');

    if (categoryLinks.length === 0 || categoryGroups.length === 0) return;

    // Show first category by default
    const firstActiveLink = document.querySelector('.faq-category-link.active');
    if (firstActiveLink) {
        const targetId = firstActiveLink.getAttribute('href')?.substring(1);
        const targetGroup = document.getElementById(targetId);
        if (targetGroup) {
            targetGroup.classList.add('active');
        }
    } else if (categoryGroups[0]) {
        // Fallback: activate first group if no active link
        categoryGroups[0].classList.add('active');
        if (categoryLinks[0]) {
            categoryLinks[0].classList.add('active');
        }
    }

    // Add click handlers to category links
    categoryLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = link.getAttribute('href')?.substring(1);
            if (!targetId) return;

            // Update active states on links
            categoryLinks.forEach(l => l.classList.remove('active'));
            link.classList.add('active');

            // Close any open FAQ items in all groups
            document.querySelectorAll('.faq-item.open').forEach(item => {
                item.classList.remove('open');
                const toggle = item.querySelector('.faq-toggle');
                if (toggle) toggle.setAttribute('aria-expanded', 'false');
            });

            // Animate out current, animate in new
            categoryGroups.forEach(group => {
                if (group.id === targetId) {
                    group.classList.add('active');
                } else {
                    group.classList.remove('active');
                }
            });
        });
    });
}
